import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";

export default function OverdragTilAndenPersonArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <ul className="list list--bullet">
                            <li><p>
                                Kontakt os gerne hurtigst muligt, når du skal overdrage dit abonnement til en anden person &ndash; det kan nemlig tage lidt tid.
                            </p></li>
                            <li><p>
                                Grundet GDPR-hensyn kan vi ikke ændre navnet på abonnementet.
                                I stedet skal vi oprette et nyt produkt i overtagerens navn.
                                Så er vi nemlig sikre på, at al personlig information på abonnementet er korrekt.
                            </p></li>
                        </ul>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Sådan overdrager du dit internet til en anden person:</h2>
                        <ol className="list list--number">
                            <li>
                                <p>Du (person 1) skal sende en mail til os på <a href="mailto:kundeservice@hiper.dk">kundeservice@hiper.dk</a>.</p>
                                <ul className="list list--number">
                                    <li><p>
                                        I mailen skal du skrive:<br/>
                                        &ldquo;Jeg ønsker at overdrage mit abonnement på <i>(din adresse)</i> til <i>(navnet på overtageren)</i> d. <i>(dd/mm-åå)</i>.&rdquo;
                                    </p></li>
                                    <li><p>
                                        Sæt personen (person 2), der skal overtage abonnementet, på cc i mailen
                                    </p></li>
                                </ul>
                            </li>
                            <li><p>
                                Person 2 skal besvare mailen med navn, email og telefonnummer.
                                Så har vi nemlig accept på, at vi må oprette et nyt abonnement til person 2.
                            </p></li>
                            <li><p>
                                Når person 2 har givet sin accept, opretter vi et nyt abonnement til person 2 på den samme adresse.
                            </p></li>
                            <li>
                                <p>
                                    Person 1 får en opsigelsesmail, hvor der står, at abonnementet er opsagt.
                                </p>
                                <p>
                                    Ofte kan person 2 beholde routeren &ndash; hvis du (person 1) får en mail, hvor der står, at du skal returnere routeren, må du gerne kontakte os.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Person 2 får en mail med ordrebekræftelse og nyt kundenummer samt en velkomstmail med en dato, hvor internettet er klar.
                                </p>
                                <p>
                                    Er online datoen langt ude i fremtiden?
                                    Så kan du kontakte os så kan vi prøve at finde en tidligere dato i systemet.
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "mit-abonnement",
                        "article": "skal-du-flytte",
                        "name": "Skal du flytte?"
                    },
                    {
                        "category": "udstyr",
                        "article": "hvilken-router-foelger-med",
                        "name": "Hvilken router følger med?"
                    },
                    {
                        "category": "bestilling",
                        "article": "ny-online-dato",
                        "name": "Vil du ændre datoen, dit internet er klar?"
                    },
                    {
                        "category": "bestilling",
                        "article": "ny-teknikertid",
                        "name": "Sådan ændrer du din teknikertid"
                    }
                ]}
            />
        </>
    )
}
